let sequence = 0;

/**
 * A tracker belongs to one room component. Only the current query's pending
 * request may change its result list; page progress changes after success.
 */
export function createSearchTracker() {
    let active = null;
    let pending = null;
    let lastSuccessfulPage = 0;

    function pageRequest(pageIndex) {
        const requestId = 'search-' + Date.now().toString(36) + '-' + (++sequence).toString(36);
        pending = {
            requestId, name: active.query, source: active.source,
            pageIndex, pageSize: active.pageSize, sendTime: Date.now()
        };
        return {...pending};
    }

    return {
        begin({query, source = 'qq', pageSize = 20}) {
            active = {
                query: String(query == null ? '' : query).trim(),
                source: String(source || 'qq').trim().toLowerCase() || 'qq',
                pageSize: Math.max(1, Math.min(100, Math.floor(Number(pageSize) || 20)))
            };
            lastSuccessfulPage = 0;
            return pageRequest(1);
        },

        // Editing the input does not alter active.query. A failed page is retried.
        nextPage() {
            if (!active || pending) return null;
            return pageRequest(lastSuccessfulPage + 1);
        },

        receive(response) {
            const page = response && response.data;
            if (!pending || !page || page.requestId !== pending.requestId ||
                page.query !== active.query || page.source !== active.source ||
                Number(page.pageIndex) !== pending.pageIndex || Number(page.pageSize) !== active.pageSize) {
                return {accepted: false};
            }
            const pageIndex = pending.pageIndex;
            pending = null;
            if (Number(response.code) !== 20000 || !Array.isArray(page.data)) {
                return {accepted: true, status: 'failure', append: pageIndex > 1, page,
                    reason: response.message || '搜索暂时失败，请重试'};
            }
            lastSuccessfulPage = pageIndex;
            return {accepted: true, status: 'success', append: pageIndex > 1, page, reason: ''};
        },

        // A timeout for an earlier request must not cancel a replacement request.
        expire(requestId) {
            if (!pending || pending.requestId !== requestId) return false;
            pending = null;
            return true;
        },

        reset() {
            active = null;
            pending = null;
            lastSuccessfulPage = 0;
        },

        getState() {
            return {
                query: active ? active.query : '', source: active ? active.source : 'qq',
                pageSize: active ? active.pageSize : 20, lastSuccessfulPage,
                pendingRequestId: pending ? pending.requestId : '', isPending: !!pending
            };
        }
    };
}
